import { Dashboard } from './components/Dashboard';
import './index.css';

function App() {
  return (
    <div className="app">
      <Dashboard />
    </div>
  );
}

export default App;